import { Component, OnInit,Input } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { ExportActivityLogComponent } from '../export-activity-log/export-activity-log.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-preview-activity-log',
  templateUrl: './preview-activity-log.component.html',
  styleUrls: ['./preview-activity-log.component.scss']
})
export class PreviewActivityLogComponent implements OnInit {
  subGetAuditLogDetailsList: SubscriptionLike;
  @Input() public Content: any;
  gridApi: GridApi;
  selectedRow: any;
  columnDefs: any;
  rowData: any = [];
  public content: any;
  details_data: any;
  ApplicationId: string;
  ModuleId: string;
  GrantType:string;
  action: Subject<any> = new Subject();
  gridBar:boolean=false;
  gridOptions: { pagination: boolean; rowSelection: string; rowHeight: number; defaultColDef: { sortable: boolean; suppressNavigable: boolean; cellClass: string; suppressMovable: boolean; }; };
  context: any;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public apiService: ApidataRequestService,
  ) { }

  ngOnInit(): void {
    this.gridBar=false;
    this.ModuleId = this.Content.content.ModuleId;
    this.gridHeaderandActionSettings(this.ModuleId);
    this.ApplicationId = this.Content.content.ApplicationId;   
    this.GrantType = this.Content.content.GrantType;
    this.subGetAuditLogDetailsList = this.apiService.getData("api/IEGAuditActivityLogs/GetIEGActivityLogByApplicationId?ApplicationId=" + this.ApplicationId + "&ModuleId=" + this.ModuleId+"&GrantType="+this.GrantType).subscribe((result) => {
      if (result.Status && result.Data.length > 0) {
        this.rowData = result.Data;
        this.details_data = this.rowData;
      } else {
        this.rowData = [];
        this.details_data = [];
      }
    });
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,     
      
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        
      }
    }
    this.context = { componentParent: this };
  }

  ngOnDestroy(): void {
    if (this.subGetAuditLogDetailsList) this.subGetAuditLogDetailsList.unsubscribe();
  }

  gridHeaderandActionSettings(MdID:string) {
    if(MdID=="grants")
    {
    this.columnDefs = [
      { headerName: "Activities #", headerTooltip: "Activities #", field: 'Activities', sortable: false, resizable: true, tooltipField: 'Activities' },
      { headerName: "Username", headerTooltip: "Username", field: "Username", sortable: false, resizable: true, tooltipField: "Username" },
      { headerName: "Application ID", headerTooltip: "Application ID", field: 'ApplicationID', sortable: false, resizable: true, tooltipField: "ApplicationID" },
      { headerName: "Grant Type", headerTooltip: "Grant Type", field: 'GrantType', sortable: false, tooltipField: "GrantType" },
      { headerName: "Actions", headerTooltip: "Actions", field: 'Actions', sortable: false, resizable: true, tooltipField: "Actions" },
      { headerName: "Description", headerTooltip: "Description", field: 'Description', sortable: false, resizable: true, tooltipField: "Description" },
      { headerName: "Assigned To", headerTooltip: "Assigned To", field: 'AssignedTo', sortable: false, resizable: true, tooltipField: "AssignedTo" },
      { headerName: "Previous State", headerTooltip: "Previous State", field: 'PreviousState', sortable: false, resizable: true, tooltipField: "PreviousState" },
      { headerName: "Current State", headerTooltip: "Current State", field: 'CurrentState', sortable: false, resizable: true, tooltipField: "CurrentState" },
      { headerName: "Performed on Date & Time", headerTooltip: "Performed on Date & Time", field: 'PerformedonDateTime', sortable: false, resizable: true, tooltipField: "PerformedonDateTime" }

    ];
  }
  else 
  {
    this.columnDefs = [
      { headerName: "Activities #", headerTooltip: "Activities #", field: 'Activities', sortable: false, resizable: true, tooltipField: 'Activities' },
      { headerName: "Username", headerTooltip: "Username", field: "Username", sortable: false, resizable: true, tooltipField: "Username" },
      { headerName: "Application ID", headerTooltip: "Application ID", field: 'ApplicationID', sortable: false, resizable: true, tooltipField: "ApplicationID" },
      { headerName: "Actions", headerTooltip: "Actions", field: 'Actions', sortable: false, resizable: true, tooltipField: "Actions" },
      { headerName: "Description", headerTooltip: "Description", field: 'Description', sortable: false, resizable: true, tooltipField: "Description" },
      { headerName: "Assigned To", headerTooltip: "Assigned To", field: 'AssignedTo', sortable: false, resizable: true, tooltipField: "AssignedTo" },
      { headerName: "Previous State", headerTooltip: "Previous State", field: 'PreviousState', sortable: false, resizable: true, tooltipField: "PreviousState" },
      { headerName: "Current State", headerTooltip: "Current State", field: 'CurrentState', sortable: false, resizable: true, tooltipField: "CurrentState" },
      { headerName: "Performed on Date & Time", headerTooltip: "Performed on Date & Time", field: 'PerformedonDateTime', sortable: false, resizable: true, tooltipField: "PerformedonDateTime" }

    ];
  }
  }


  onSetGridApi(params) {
    this.gridApi = params.api;;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }


  cancelmodal() {
    this.modalRef.dismiss();
  }


  ExportToPDF() {
    let modalRef = this.modalService.open(ExportActivityLogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: {
        ID: null,
        OperationType: "View",
        details_data: this.details_data,
        ModuleId:this.ModuleId
      }
    }

  }
}

